import { useTranslation } from 'react-i18next';

import { useAccountSwitchNotificationFromUrl } from '@/features/account/hooks/use-account-switch-notification-from-url';
import { WithHtmlSavvyTitle } from '@/with-html-savvy-title';
import { Dashboard } from './dashboard/dashboard';

export const HomePage = () => {
  const { t } = useTranslation('homepage');

  useAccountSwitchNotificationFromUrl();

  return (
    <WithHtmlSavvyTitle title={t`page.title`}>
      <Dashboard />
    </WithHtmlSavvyTitle>
  );
};
